module.exports = __webpack_public_path__ + "resources/img/img_ai_easymaker_m_en.66d0c478d24000f6d0529c0ca42dd1bf.png";